import { PayloadAction } from 'typesafe-actions';

// принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
export type GaProductBelong = 'LeroyMerlin' | 'LeroyMerlinMarketplace' | 'Longtail';
export type DispatchGaMessage = PayloadAction<string, unknown>;
export enum PriceCategoryGaNames {
  PIM = 'onlineOnly',
  BPR = 'bestPrice',
  LOF = 'offerLimited',
  STD = 'discount',
}
